var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    [
      _c(
        "el-header",
        { staticClass: "nav-container" },
        [
          _c("navbar", {
            attrs: { "nav-index": "/project" },
            on: { "nav-items-click": _vm.navClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("sidebar", {
            attrs: {
              items: _vm.projectRouters,
              "create-button-title": _vm.permissonProject ? "创建项目" : "",
              "create-button-icon": "el-icon-plus",
            },
            on: {
              quicklyCreate: _vm.quicklyCreate,
              select: _vm.siderbarSelect,
            },
          }),
          _vm._v(" "),
          _c(
            "el-main",
            { attrs: { id: "project-container" } },
            [
              _c("app-main"),
              _vm._v(" "),
              _c("project-board", {
                attrs: { visible: _vm.projectBoardShow },
                on: {
                  "update:visible": function ($event) {
                    _vm.projectBoardShow = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("tag-board", {
                attrs: { visible: _vm.tagBoardShow },
                on: {
                  "update:visible": function ($event) {
                    _vm.tagBoardShow = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isCreate
        ? _c("add-project", {
            attrs: { "enter-detail": "" },
            on: {
              close: function ($event) {
                _vm.isCreate = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }